<!--
// FOR VNEXT-1726
// THIS FIELD CAN NO LONGER BE SELECTED IN THE FORM BUILDER
// Existing uses of it remain and function, you just can't create a new one in Forms Templates anymore
// FLEX FIELDS ARE NOW TO BE USED FOR ALL MULTI-SELECT FUNCTIONALITY
-->
<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-template #tooltipTemplate><ng-content select="[projectedTooltip]"></ng-content></ng-template>

<div class="outer-div">
  @if (this.Mode === 'design') {
    <div class="inner-div">
      <div class="design-mode-field-label">{{this.DisplayName}}</div>
      @if ((this.CheckboxData === undefined) || (this.CheckboxData === null) || (this.CheckboxData.length === 0)) {
        <mat-checkbox disabled>No checkboxes defined</mat-checkbox>
      }
      @if ((this.CheckboxData !== undefined) && (this.CheckboxData !== null) && (this.CheckboxData.length > 0)) {
        <section>
          <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
          @for (checkboxData of this.CheckboxData; track checkboxData; let i = $index) {
            <mat-checkbox [(ngModel)]="checkboxData.value"
              (ngModelChange)="this.handleCheckboxModelChange(i)"
              disabled
            class="set-left-align">{{checkboxData.title}}</mat-checkbox>
            @if ((i < this.CheckboxValueCount - 1) && (this.FormField.displayFormat === 'Vertical')) {
              <br />
            }
            @if ((i < this.CheckboxValueCount - 1) && (this.FormField.displayFormat !== 'Vertical')) {
              &nbsp;&nbsp;&nbsp;
            }
          }
        </section>
      }
      <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
    </div>
  }

  @if ((this.Mode === 'preview') || (this.Mode === 'instance')) {
    <div>
      @if (!FieldIsInGrid) {
        <div class="field-label">{{this.DisplayName}}</div>
      }
      @if ((this.CheckboxData === undefined) || (this.CheckboxData === null) || (this.CheckboxData.length === 0)) {
        <mat-checkbox disabled>No checkboxes defined</mat-checkbox>
      }
      @if ((this.CheckboxData !== undefined) && (this.CheckboxData !== null) && (this.CheckboxData.length > 0)) {
        <section>
          <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
          @for (checkboxData of this.CheckboxData; track checkboxData; let i = $index) {
            <mat-checkbox [formControl]="this.getCheckboxFormControl(i)"
              (blur)="this.handleOnBlur()"
              class="set-left-align"
              [ngClass]="this.ReadOnly ? 'pointer-events: none; opacity: 0.5; mat-checkbox-disabled: true;' : ''">
              {{checkboxData.title}}
            </mat-checkbox>
            @if ((i < this.CheckboxValueCount - 1) && (this.FormField.displayFormat === 'Vertical')) {
              <br />
            }
            @if ((i < this.CheckboxValueCount - 1) && (this.FormField.displayFormat !== 'Vertical')) {
              &nbsp;&nbsp;&nbsp;
            }
          }
        </section>
      }
    </div>
  }
  <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
</div>
